import i18n from "i18next";
import React from "react";
import { render } from "react-dom";
import { initReactI18next } from "react-i18next";
import App from "./App";

import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./adConfig";
import "./cognitoConfig";
import EN_JSON from "./en.json";
export const msalInstance = new PublicClientApplication(msalConfig);
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  // console.log("acc found", accounts);
  msalInstance.setActiveAccount(accounts[0]);
} else {
  console.log("no accout found");
}


msalInstance.handleRedirectPromise().then(response => {
  if (response !== null) {
    msalInstance.setActiveAccount(response.account);
    // console.log("redirect success", response);
  } else {
    console.error('Redirect failed or user canceled.');
  }
});



i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: EN_JSON,
    },
    lng: "en", // if you're using a language detector, do not define the lng option
    fallbackLng: "en",
    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
// serviceWorkerRegistration.register();

const startApp = () => {
  render(
    <React.StrictMode>
      <App pca={msalInstance} />
    </React.StrictMode>,
    document.getElementById("root")
  );
};
startApp();
// serviceWorkerRegistration.register();
// serviceWorkerRegistration.registerFirebase();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
